import { Box, Typography } from "@mui/material";
import SourceIcon from "./sourceIcon";

const Function_executed = ({ log }) => {
  return (
    <Box dir="rtl">
      {/* Header with icon */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        {/* Main content */}
        <Box>
          {log?.action === "added" ? (
            <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
              הוספת רשומה{log.details?.record?.module ? ` למודול ${log.details.record.module}` : ""}
            </Typography>
          ) : log?.action === "updated" || log?.action === "function_executed" ? (
            <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
              עדכון ברשומה{log.details?.record?.module ? ` ${log.details.record.module}` : ""}
            </Typography>
          ) : (
            <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
              {log.details?.automationDetails?.name ||
                log.details?.automationDetails?.rule?.name ||
                log.details?.relatedRecord?.name ||
                log.details?.record?.name ||
                log?.action ||
                "פעולה"}
            </Typography>
          )}

          {log.details.relatedRecord?.module && (
            <Box sx={{ pr: 2 }}>
              {" "}
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                רשומת אב: {log.details?.relatedRecord?.module}
              </Typography>
            </Box>
          )}
        </Box>

        {/* Icon */}
        <Box sx={{ ml: 2 }}>
          <SourceIcon source={log.source} />
        </Box>
      </Box>

      {/* Changed Fields */}
      <Box sx={{ mt: 1 }}>
        {log.details?.changedFields?.map((field, ind) => (
          <Box
            key={ind}
            sx={{
              mb: 0.5,
              display: "flex",
              justifyContent: "flex-start", // This will push content to the right in RTL
            }}
          >
            {field.oldValue !== null ? (
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                }}
              >
                שדה <strong>{field?.fieldName}</strong> עודכן מ:{" "}
                <span style={{ direction: "ltr", display: "inline-block" }}>
                  {field.oldValue}
                </span>{" "}
                ל:{" "}
                <span style={{ direction: "ltr", display: "inline-block" }}>
                  {field.newValue}
                </span>
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                }}
              >
                שדה <strong>{field?.fieldName}</strong> אותחל בערך:{" "}
                <span style={{ direction: "ltr", display: "inline-block" }}>
                  {field.newValue}
                </span>
              </Typography>
            )}
          </Box>
        ))}
      </Box>

      {/* User Info */}
      <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-start" }}>
        <Typography variant="body2">
          על ידי: {log.details.user?.name}
        </Typography>
      </Box>

      {/* Automation Details */}
      {log.details.automationDetails && (
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ whiteSpace: "nowrap" }}
          >
            פעולה: {log.details.automationDetails?.name}{" "}
            {log.details.automationDetails?.rule?.name} | באמצעות:{" "}
            {log.details.automationDetails.type}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Function_executed;